export const roles = {
  CompanyAdmin: 'Admin',
  CompanySupervisor: 'Site Supervisors',
}
